import { ref } from "vue";

export function useGeolocation() {
  const latitude = ref(null);
  const longitude = ref(null);
  const error = ref(null);

  const getLocation = () => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          latitude.value = position.coords.latitude;
          longitude.value = position.coords.longitude;
        },
        (err) => {
          error.value = "Erro ao obter localização: " + err.message;
        }
      );
    } else {
      error.value = "Geolocalização não suportada pelo navegador.";
    }
  };

  return {
    latitude,
    longitude,
    error,
    getLocation
  };
}
